module.exports = __webpack_public_path__ + "img/ealigner-headquarters.85a58735.jpg";